import {Action, view, Icon} from '@sail/ui';
import {chevronRight} from '@sail/icons/react/Icon';
import type {IconAsset} from '@sail/icons/types';
import {COLORS} from 'src/v2/util/color';
import {Text} from 'src/v2/components/common';
import {safeWindowOpen} from '@stripe-internal/safe-links';

type Props = {
  browsers: Array<{
    id: string;
    label: string;
    icon: IconAsset;
    extensionUrl: string;
  }>;
};

export const BrowserSelector = ({browsers}: Props) => {
  return (
    <view.div
      css={{stack: 'y', gapY: 'space.150'}}
      data-testid="browser-selector"
    >
      {browsers.map(({id, label, extensionUrl, icon}) => (
        <Action
          key={id}
          onPress={() => {
            safeWindowOpen(extensionUrl);
          }}
          css={{
            stack: 'x',
            backgroundColor: COLORS.offsetOnLight,
            borderRadius: 'small',
            paddingX: 'space.150',
            paddingY: 'medium',
            alignY: 'center',
            distribute: 'space-between',
            width: 'fill',
          }}
        >
          <view.div css={{stack: 'x', gap: 'small', alignY: 'center'}}>
            <Icon icon={icon} size="medium" />
            <Text type="bodyEmphasized">{label}</Text>
          </view.div>
          <Icon icon={chevronRight} size="xsmall" />
        </Action>
      ))}
    </view.div>
  );
};
